(function($) {
    // Populates a select drop-down with options in a list
    const regex = /#038;/ig;
    $.fn.populate = function(list) {
        return this.append(list.map(item => $('<option>', {
            text  : item.name.replace(regex, ''),
            value : item.id
        })));
    };

    $('.portal-stores-dropdown select').empty().populate(window.portalStores);

})(jQuery);


